import Utils from "../Utils";

/**
 * 
 */
class Url {

    static maps = Utils.getUrlParamsMaps();

    static getItem(name: string) {
        return Url.maps[name];
    }

    static setItem(name: string, value: any) { }

    static removeItem(name: string) { }
}

export default Url;